export default function getPage () {
  const urlParts = document.URL.split('/');
  return urlParts[3] || 'dashboard';
}